import { Component, EventEmitter, Input, Output } from "@angular/core";
import {
  Events,
  NavController,
  NavParams,
  ViewController,
} from "ionic-angular";
import {
  DropdownItem,
  Order,
  OrderComponent,
} from "models/order-management/models";
import { OrderFormState } from "pages/orders-entry-om/add-order/order-form-state";
import Utils from "utils/Utilities";
import { StateManagementService } from "../../../providers/state-management/state-management.service";
import {
  OrderComponentInterface,
  OrderComponentPropertyUpdate,
  OrderCreateRequestUpdate,
} from "../order-components-interface";

@Component({
  selector: "patient-location",
  templateUrl: "patient-location.html",
})
export class PatientLocationComponent implements OrderComponentInterface {
  /****************************************************************************
   * Inputs                                                                   *
   ****************************************************************************/
  @Input() orderComponent: OrderComponent;
  @Input() orderCreateRequest: Order;
  @Input() set orderFormState(orderFormState: OrderFormState) {
    this._orderFormState = orderFormState;
    this.careLocationType = orderFormState.careLocationType;
    this.careLocation = orderFormState.careLocation;
    if (this.careLocation) {
      this.getAddressInfo();
    }

    if (!this.careLocationType || !this.careLocation) {
      this.clearInfo();
    }
  }

  /****************************************************************************
   * Outputs                                                                  *
   ****************************************************************************/
  @Output() orderCreateRequestEvent =
    new EventEmitter<OrderCreateRequestUpdate>();
  @Output() orderFormStateEvent = new EventEmitter<OrderFormState>();
  @Output() isValidEvent = new EventEmitter<boolean>();
  @Output() amendedOrderRequestEvent =
    new EventEmitter<OrderComponentPropertyUpdate>();

  /****************************************************************************
   * State                                                                    *
   ****************************************************************************/
  dropdownItems: DropdownItem[] = [];
  careLocationType: string;
  careLocation: string;
  _orderFormState: OrderFormState;
  data: DropdownItem[] = [];
  labelToKeyMapOrderAddress = {
    "Phone Number": "phoneNumber",
    "Fax Number": "faxNumber",
    "Email Address": "emailAddress",
    Address: "address1",
  };

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public viewCtrl: ViewController,
    public events: Events,
    public stateData: StateManagementService
  ) {}

  /****************************************************************************
   * Lifecycle Methods                                                        *
   ****************************************************************************/
  ngOnInit() {
    this.loadLabels();
    this._orderFormState.formType === "amendment"
      ? this.setAmendedValue()
      : null;
  }

  /****************************************************************************
   * Getter Methods                                                           *
   ****************************************************************************/
  get isDisabled() {
    if (this._orderFormState.careLocationType) {
      return true;
    }
    return false;
  }

  getAddressInfo() {
    this.dropdownItems = this.dropdownItems.map((item) => {
      const label = item.label;
      const valueKey = this.labelToKeyMapOrderAddress[label];
      const patientLocation = this._orderFormState.patientLocation;

      let value = patientLocation[valueKey];

      if (label === "Address") {
        value = Utils.transformAddress(patientLocation);
      }
      item.value = value && value !== "" ? value : "--";
      return item;
    });
  }

  /****************************************************************************
   * Setter Methods                                                           *
   ****************************************************************************/
  setAmendedValue() {
    const componentField: string = this.orderComponent.properties[0].name;
    this.getAddressInfo();
    this.checkIsValid();
  }

  /****************************************************************************
   * Component Related Methods                                                *
   ****************************************************************************/
  clearInfo() {
    this.dropdownItems = this.dropdownItems.map((item) => {
      item.value = "--";
      return item;
    });
  }

  loadLabels() {
    this.dropdownItems = this.orderComponent.properties[0].dropdownItems;
  }

  checkIsValid() {
    this.isValidEvent.emit(true);
  }

  /****************************************************************************
   * Cypress-Related ("data-cy") Methods                                      *
   ****************************************************************************/
  toKebabCase(label: string): string {
    if (label) {
      return label
        .replace(/^\s+|\s+$/gm, "")
        .replace(/([a-z])([A-Z])/g, "$1-$2")
        .replace(/[\s_]+/g, "-")
        .toLowerCase();
    }
    return "";
  }

  createDataCyAttribute(component: string, option: string): string {
    return `${this.toKebabCase(component)}-option-${this.toKebabCase(option)}`;
  }
}



// WEBPACK FOOTER //
// ./src/components/order-management/patient-location/patient-location.ts